import { DEFAULT_LANG } from "../constants";
export const FALLBACK_LANG = DEFAULT_LANG;
